export type RedactionRect = { x:number; y:number; width:number; height:number };

export function normalizeRect(rect:RedactionRect):RedactionRect {
  const x = Math.max(0, Math.min(100, rect.x));
  const y = Math.max(0, Math.min(100, rect.y));
  return {
    x, y,
    width:Math.max(1, Math.min(100 - x, rect.width)),
    height:Math.max(1, Math.min(100 - y, rect.height))
  };
}

function canvasBlob(canvas:HTMLCanvasElement, quality:number) {
  return new Promise<Blob>((resolve, reject) => canvas.toBlob(
    (blob) => blob ? resolve(blob) : reject(new Error('가린 이미지를 만들지 못했어요.')),
    'image/jpeg', quality
  ));
}

export async function renderRedactedImage(file:File, redactions:RedactionRect[]) {
  const image = await createImageBitmap(file, { imageOrientation:'from-image' });
  try {
    if (image.width * image.height > 16_000_000) throw new Error('이미지는 1,600만 화소 이하로 줄여 주세요.');
    const scale = Math.min(1, 1600 / Math.max(image.width, image.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.width * scale));
    canvas.height = Math.max(1, Math.round(image.height * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('가림 도구를 열지 못했어요.');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    context.fillStyle = '#101820';
    for (const raw of redactions) {
      const rect = normalizeRect(raw);
      context.fillRect(rect.x / 100 * canvas.width, rect.y / 100 * canvas.height, rect.width / 100 * canvas.width, rect.height / 100 * canvas.height);
    }
    let blob = await canvasBlob(canvas, .88);
    if (blob.size > 2_500_000) blob = await canvasBlob(canvas, .72);
    if (blob.size > 2_500_000) throw new Error('가린 이미지가 2.5MB를 넘어요. 더 작은 사진을 골라 주세요.');
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '-redacted.jpg', { type:'image/jpeg', lastModified:Date.now() });
  } finally {
    image.close();
  }
}
